import { render, staticRenderFns } from "./MultiDropdown.vue?vue&type=template&id=3fb6806e&shadow"
import script from "./MultiDropdown.vue?vue&type=script&lang=js&shadow"
export * from "./MultiDropdown.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports